<template>
  <div class="account-breadcrumb">
    <ul>
      <li>
        <router-link :to="{ name: 'home' }">
          {{ _T('Home') }}
          <img src="/images/svg/global/arrow-right-r.svg" alt="" />
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'profile.ongoing-orders' }">
          {{ _T('My Orders') }}
          <!-- <img src="/images/svg/global/arrow-right-r.svg" alt="" /> -->
        </router-link>
      </li>
      <!-- <li>{{ _T('My Order Details') }}</li> -->
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'OrdersBreadCrumb',
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .account-menu {
    .account-breadcrumb {
      ul {
        padding-left: unset;
        padding-right: 0;
        text-align: right;
      }
    }
  }
}
.account-breadcrumb {
  ul {
    li {
      line-height: $px17;
      letter-spacing: 0.005em;
      a {
        font-weight: 600;
      }
      img {
        margin-left: $px12;
        margin-right: $px7;
      }
    }
  }
  .breadcrumb-innerpage {
    li {
      font-weight: 600;
    }
  }
}
@media (max-width: 575px) {
  .account-breadcrumb {
    display: none;
  }
}
</style>
